import { WebEvent } from './EventGrid';

const TTL_MS = 3 * 60 * 1000;

export function readCachedEvents(key: string): WebEvent[] | null {
    try {
        const raw = sessionStorage.getItem(key);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (!parsed || Date.now() - Number(parsed.time || 0) > TTL_MS) {
            sessionStorage.removeItem(key);
            return null;
        }
        return Array.isArray(parsed.events) ? parsed.events : null;
    } catch {
        return null;
    }
}

export function writeCachedEvents(key: string, events: WebEvent[]): void {
    try {
        sessionStorage.setItem(key, JSON.stringify({ time: Date.now(), events }));
    } catch {
        /* Storage can be unavailable in private modes. The app still works. */
    }
}
